/*
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3945 Freedom Circle, Suite 730 Santa Clara, CA 95054
 * All rights reserved.
 */

/* eslint react/jsx-props-no-spreading: 0 */
/* eslint react/prop-types: 0 */

import React from 'react'
import {
  Heatmap,
  WordCloud,
  Bar,
  Line,
  Area,
  Pie,
  Donut,
  Gauge,
  Stream,
  Sparkline
} from '@netbasequid/chart'
import PlaceHolder from '../../share/PlaceHolder'
import Table from './Table'
import { useDisplayTheme } from '../../../hooks/useUiState'

const ChartFactory = ({ type, data, config }) => {
  const displayTheme = useDisplayTheme()

  switch (type) {
    case 'HEATMAP':
      return <Heatmap mode={displayTheme} data={data} {...config} />
    case 'WORDCLOUD':
      return <WordCloud mode={displayTheme} data={data} {...config} />
    case 'BAR':
      return <Bar mode={displayTheme} data={data} {...config} />
    case 'LINE':
      return <Line mode={displayTheme} data={data} {...config} />
    case 'AREA':
      return <Area mode={displayTheme} data={data} {...config} />
    case 'PIE':
      return <Pie mode={displayTheme} data={data} {...config} />
    case 'DONUT':
      return <Donut mode={displayTheme} data={data} {...config} />
    case 'GAUGE':
      return <Gauge mode={displayTheme} data={data} {...config} />
    case 'STREAM':
      return <Stream mode={displayTheme} data={data} {...config} />
    case 'SPARKLINE':
      return <Sparkline mode={displayTheme} data={data} {...config} />
    case 'TABLE':
      return <Table mode={displayTheme} data={data} config={config} />
    default:
      return <PlaceHolder />
  }
}

export default ChartFactory
